<template>
  <div>
    <Survey v-if="surveyShow" :step="1" @fnTab="fnTab" @confirm="fnConfirm" />
    <Register v-if="registerShow" :step="2" @fnTab="fnTab" @confirm="fnConfirm" />
    <Complete v-if="completeShow" :rlt-msg="rltMsg" @confirm="fnConfirm" />
    <Confirm v-if="confirmShow" :step="step" @fnTab="fnTab" @confirmResult="fnConfirmResult"/>
    <Result v-if="resultShow" :step="step" @fnTab="fnTab" />
    <Result2 v-if="result2Show" :step="step" @fnTab="fnTab" />
    <PolicyPopup v-if="policyPopupShow" :policy-num="policyNum" @closePolicyPopup="fnClosePolicyPopup" />
  </div>
</template>
<script>
import Survey from '~pages/contents/main/Survey.vue'
import Register from '~pages/contents/main/Register.vue'
import Complete from '~pages/contents/main/Complete.vue'
import Confirm from '~pages/contents/main/Confirm.vue'
import Result from '~pages/contents/main/Result.vue'
import Result2 from '~pages/contents/main/Result2.vue'
import { isEmpty } from 'lodash'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import PolicyPopup from '~pages/contents/main/PolicyPopup.vue'

export default {
  name: 'SurveyConfirm',
  metaInfo () {
  },
  components: {
    Survey,
    Register,
    Complete,
    Confirm,
    Result,
    Result2,
    PolicyPopup
  },
  data () {
    return {
      surveyShow: true,
      registerShow: false,
      completeShow: false,
      confirmShow: false,
      resultShow: false,
      result2Show: false,
      policyPopupShow: false,
      step: '',
      rltMsg: {},
      params: {
        registerTitleData: {},
        registerResultData: {},
        surveyTitleData: {},
        surveyResultData: {},
        mbrFnm: '',
        emailAddr: '',
        mbrCelno: '',
        wepId: this.getStore('mmpAuth').state.saveId
      },
      basePath: this.getStore('mmpAuth').state.basePath,
      policyNum: '',
      rtnCode:''
    }
  },
  computed: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    // 설문작성 파일 존재 여부 체크
    this.fnSurveyExist()
  },
  methods: {
    fnSurveyExist () {
      let resourceUrl = this.getTemplatePath('wepSurvey.html')
      this.$http.loadRes(resourceUrl).then((res) => {
        if (isEmpty(res)) {
          this.surveyShow = false
          this.registerShow = true
        } else {
          wepHtmlToString.firstSubTemplate = res
        }
      })
    },
    fnTab (obj) {
      if (obj.stepNum === 0) {
        // 약관
        this.policyNum = obj.idx
        this.policyPopupShow = true
        this.setOverflow(true)
      } else {
        this.fnSetData(obj)
      }
    },
    fnTabShow (stepShow, stepOne, stepTwo, stepThree, stepFour, stepFive, stepSix) {
      this.step = stepShow
      this.surveyShow = stepOne
      this.registerShow = stepTwo
      this.completeShow = stepThree
      this.confirmShow = stepFour
      this.resultShow = stepFive
      this.result2Show = stepSix
      window.scrollTo(0, 0)
    },
    fnConfirm (arg) {
      this.fnTabShow(arg, false, false, false, true, false, false)
    },
    fnConfirmResult (obj) {
      if (obj.regFlag === '01') {
        this.fnTabShow(obj.stepNum, false, false, false, false, true, false)
      } else {
        this.fnTabShow(obj.stepNum, false, false, false, false, false, true)
      }
    },
    async fnSetData (obj) {
      if (obj.stepNum === '1') {
        // 설문작성
        this.params.registerTitleData = {}
        this.params.registerResultData = {}
        this.params.surveyTitleData = {}
        this.params.surveyResultData = {}
        this.params.mbrFnm = ''
        this.params.emailAddr = ''
        this.params.mbrCelno = ''
        this.fnTabShow(obj.stepNum, true, false, false, false, false, false)
      } else if (obj.stepNum === '2') {
        // 참가신청
        if (!isEmpty(obj.params)) {
          this.params.surveyTitleData = obj.params.title
          this.params.surveyResultData = obj.params.input
          this.params.surveyItemTypeData = obj.params.itemType
          if (document.getElementById('survyTitlNm') !== null) {
            this.params.survyTitlNm = document.getElementById('survyTitlNm').value
          }
        }
        this.fnTabShow(obj.stepNum, false, true, false, false, false, false)
      } else {
        // 신청완료
        if (!isEmpty(obj.params)) {
          this.params.registerTitleData = obj.params.title
          this.params.registerResultData = obj.params.input
          this.params.mbrFnm = obj.params.input[0].data
          this.params.emailAddr = obj.params.input[1].data
          this.params.mbrCelno = obj.params.input[2].data
          this.params.registerItemTypeData = obj.params.itemType
          this.params.survyScCd = '01'
          this.params.language = localStorage.getItem('language')
          let resultInfo = await this.$http.mmp.surveyConfirm(this, this.params)
          if (resultInfo.data.status !== 'OK') {
          } else {
            this.rtnCode = resultInfo.data.data.rltCode
            console.log('rtnvale', resultInfo.data.data.rltCode)
            if (resultInfo.data.data.rltCode === '01') {
              if (window.dataLayer) {
                window.dataLayer.push({
                  event: 'memberJoin',
                  category: '(목표) 참가신청',
                  action: '참가신청'
                })
              }
              // 참가신청 완료
              this.rltMsg.msg1 = this.$t('TEMPLT004')
              this.rltMsg.msg2 = this.$t('TEMPLT005')
            } else if (resultInfo.data.data.rltCode === '02') {
              // 참가신청기간이 만료된 이벤트
              this.rltMsg.msg1 = this.$t('TEMPLT006')
              this.rltMsg.msg2 = ''
            } else if (resultInfo.data.data.rltCode === '05') {
              // 본인인증
              this.rltMsg.msg1 = this.$t('TEMPLT007')
              this.rltMsg.msg2 = this.$t('TEMPLT008')
            } else if (resultInfo.data.data.rltCode === '03') {
              // 사전 등록이 완료된 사용자
              this.rltMsg.msg1 = this.$t('TEMPLT009')
              this.rltMsg.msg2 = ''
            } else if (resultInfo.data.data.rltCode === '10') {
              // 집합정원초과
              this.commAlert(this.$t('TEMPLT012'))
              //this.rltMsg.msg1 = this.$t('TEMPLT011')
              //this.rltMsg.msg2 = ''
            } else if (resultInfo.data.data.rltCode === '09') {
              // 정원초과
              this.rltMsg.msg1 = this.$t('TEMPLT010')
              this.rltMsg.msg2 = ''
            } else {
              this.rltMsg.msg1 = this.$t('WEP00027')
              this.rltMsg.msg2 = ''
            }
          }
        }

        if (this.rtnCode  !== '10') {
          this.fnTabShow(obj.stepNum, false, false, true, false, false, false)
        }
      }
    },
    fnClosePolicyPopup () {
      this.policyPopupShow = false
      this.setOverflow(false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/SurveyConfirm.vue